module.exports = __webpack_public_path__ + "621bd386841f74e0053cb8e67f8a0604.svg";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/bower_components/Ionicons/fonts/ionicons.svg?v=2.0.0
// module id = 269
// module chunks = 0